module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#42b983"
    },
    attrs: {
      "id": "footerTemp"
    }
  }, [_c('footer', [_vm._v("written by " + _vm._s(_vm._f("uppercase")(_vm.author)) + " " + _vm._s(_vm.now) + " CopyRight@xqzh ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f2fa5fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/footerTemp.vue
// module id = 87
// module chunks = 2